import { makeUniqueId } from '@/utils';
export default {
  data() {
    return {
      isActive: false,
      placeholderText: this.getLabel('please.select.Sentence')
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    currentSelection: {
      type: Number,
      default: 0
    },
    titleAddition: {
      type: String,
      default: ''
    },
    pageTitleAddition: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    hasScrollbar: {
      type: Boolean,
      default: false
    },
    helpText: {
      type: String,
      default: ''
    }
  },
  computed: {
    randomId() {
      return makeUniqueId(this.name, 6);
    },
    selectedOption: function () {
      return this.options[this.currentSelection];
    }
  },
  mounted: function () {
    window.addEventListener("click", this.handleClick);
  },
  methods: {
    onSelectOption: function (option) {
      this.$emit('select-dropdown', option);
      this.isActive = false;
    },
    getLabel: function (key) {
      return window.Granite.I18n.get(key);
    },
    toggleOnKeydown: function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.isActive = !this.isActive;
        this.$nextTick(function () {
          const focusableSelector = this.$refs.dropdown.querySelector('.dc-form__select__selected');
          focusableSelector.focus();
        });
      }
      var $selectionList = $(event.target).nextAll('.dc-form__select__list');
      var key = event.key.toLowerCase();
      var $match;
      const placeholderText = this.getLabel('please.select.Sentence').toLowerCase();

      // iterate through all items, skipping "Please Select"
      $selectionList.find('li').not('.hidden').each(function (i, e) {
        const text = $(e).text().trim().toLowerCase();
        if (text === placeholderText) {
          return; //Skip "Please Select"
        }
        // look at all of the items to find a first char match
        if ($(e).text().trim().charAt(0).toLowerCase() == key) {
          // found a match; set reference & break out of the loop
          $match = $(e);
          // break out of the loop, we found one
          return false;
        }
      });
      if ($match) {
        $selectionList[0].scrollTo($match, 300);

        // set the item to selected (active) and focus so up/down starts here
        $selectionList.find('li').not('.hidden').each(function (i, e) {
          $(e).removeClass('dc-form__select__selected');
        });
        $match.addClass('dc-form__select__selected').focus();
      }
    },
    toggleOnKeyDownEscape: function () {
      this.isActive = !this.isActive;
      $("#dropdownUl").hide();
    },
    toggleOnClick: function () {
      this.isActive = !this.isActive;
    },
    trapKeyboardFocus(event) {
      const focusableSelector = this.$refs.dropdown.querySelectorAll('[tabindex]:not([tabindex="-1"])');
      const firstFocusableElement = focusableSelector[0];
      let lastFocusableElement = focusableSelector[focusableSelector.length - 1];
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (event.target === lastFocusableElement) {
          firstFocusableElement.focus();
        } else {
          $(".dc-form__select__option:focus").next().focus();
        }
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (event.target === firstFocusableElement) {
          lastFocusableElement.focus();
        } else {
          $(".dc-form__select__option:focus").prev().focus();
        }
      } else if (event.key === 'Tab') {
        if (event.target === lastFocusableElement) {
          this.toggleOnClick();
        }
      }
      var $selectionList = $('.dc-form__select__list');
      var key = event.key.toLowerCase();
      var $match;

      // iterate through all items
      $selectionList.find('li').not('.hidden').each(function (i, e) {
        // look at all of the items to find a first char match
        if ($(e).text().trim().charAt(0).toLowerCase() == key) {
          // found a match; set reference & break out of the loop
          $match = $(e);
          // break out of the loop, we found one
          return false;
        }
      });
      if ($match) {
        $selectionList[0].scrollTo($match, 300);

        // set the item to selected (active) and focus so up/down starts here
        $selectionList.find('li').not('.hidden').each(function (i, e) {
          $(e).removeClass('dc-form__select__selected');
        });
        $match.addClass('dc-form__select__selected').focus();
      }
    },
    handleClick: function (event) {
      if (!$(event.target).is("#dropdownUl")) {
        $(".dc-form__select__list").hide();
        $(".dc-form__select__current.active").removeClass("active");
      }
    },
    handleFocusOut(event) {
      let parent = event.target?.parentNode;
      setTimeout(() => {
        if (!parent.contains(document.activeElement) && parent != document.activeElement) {
          this.isActive = false;
        }
      }, 0);
    }
  }
};